import React from 'react';
import { MvpdSubscription } from './MvpdSubscription';
import { WebSubscription } from './WebSubscription';
import { AppPurchaseSubscription } from './AppPurchaseSubscription';
import { SignUp } from './SignUp';

export const Membership = ({
  isPauseEnabled,
  title,
  user,
  onRestartPlan,
  routes,
  subscription,
  toggleResumePlanModal,
  trackEditAccount,
  handleCancelPauseSubscription,
  nextBillInfo,
  activePlanSimplifiedName,
  activePlan,
  allPlans,
  openPlanSelectModal = false,
  navigate,
  state,
  payments,
  isRestartingSubscription,
}) => {
  const { hasSubscription, purchaseType, isSuccess } = subscription;

  if (user.hasMvpd) {
    return <MvpdSubscription mvpdId={user.mvpdId} />;
  }

  if (purchaseType === 'web' || purchaseType === 'coupon' || purchaseType === 'gift') {
    return (
      <WebSubscription
        routes={routes}
        subTitle={title}
        subscription={subscription}
        onRestartPlan={onRestartPlan}
        trackEditAccount={trackEditAccount}
        toggleResumePlanModal={toggleResumePlanModal}
        isPauseEnabled={isPauseEnabled}
        handleCancelPauseSubscription={handleCancelPauseSubscription}
        nextBillInfo={nextBillInfo}
        activePlanSimplifiedName={activePlanSimplifiedName}
        activePlan={activePlan}
        allPlans={allPlans}
        openPlanSelectModal={openPlanSelectModal}
        navigate={navigate}
        state={state}
        payments={payments}
        isRestartingSubscription={isRestartingSubscription}
      />
    );
  }

  const churnedBangoUser = subscription.isChurnedUser && purchaseType === 'bango';
  if (purchaseType && !churnedBangoUser) {
    return (
      <AppPurchaseSubscription
        subTitle={title}
        purchaseType={purchaseType}
        subscription={subscription}
        trackEditAccount={trackEditAccount}
        onRestartPlan={onRestartPlan}
        isRestartingSubscription={isRestartingSubscription}
      />
    );
  }

  if (isSuccess && !hasSubscription && (churnedBangoUser || !purchaseType)) {
    return <SignUp subTitle={title} routes={routes} />;
  }

  return null;
};
